
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "checkmark.icon",
  "use": "checkmark.icon-usage",
  "viewBox": "0 0 9 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 8\" id=\"checkmark.icon\"><g id=\"checkmark.icon_Homepage-evolution\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"checkmark.icon_4.0evolution-Homepage-Desktop-Car-Part-Ok-\" transform=\"translate(-578 -508)\" fill=\"#FFF\"><g id=\"checkmark.icon_Search\" transform=\"translate(213 350)\"><g id=\"checkmark.icon_Group-5\"><path d=\"M373.957 158.958a.311.311 0 01.043.125c0 .028-.014.07-.043.125l-5.387 6.667c-.087.083-.152.125-.195.125-.072 0-.144-.035-.216-.104l-3.05-2.833-.066-.063a.311.311 0 01-.043-.125c0-.014.014-.049.043-.104l.044-.042c.403-.417.72-.736.951-.958.087-.083.145-.125.174-.125.057 0 .13.042.216.125l1.73 1.625 4.328-5.354c.028-.028.072-.042.13-.042.043 0 .093.014.15.042l1.19.916z\" id=\"checkmark.icon_ion-checkmark---Ionicons\" /></g></g></g></g></symbol>"
});
    sprite.add(symbol);
    export default class CheckmarkIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="checkmark.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/checkmark.icon.svg